import React from 'react'
import cardStyle from './status-card.module.less'
import oamCardStyle from './oam-status-card.module.less'
import {
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons'
export interface Props {
  type: string //  运行状态
  label: string // 标题
  num: number // 数量
  mode: string //  展示模式
}
const StatusCard: React.FC<Props> = (props) => {
  const { type, label, num, mode } = props
  if (mode === 'teacher') {
    return (
      <div
        className={cardStyle.cardBox}
        style={{ backgroundColor: type == 'running' ? '#3C85FF1a':type == 'success'?'#00D1A31a': type == 'failed'?'#FE650F1a':'#F5A7221a'}}
      >
        <div className={cardStyle.statusBox}>
          {type == 'running' ? (
            <SyncOutlined style={{ color: '#3C85FF', marginRight: '5px' }} />
          ) : type == 'success' ? (
            <CheckCircleOutlined
              style={{ color: '#00D1A3', marginRight: '5px' }}
            />
          ) : type == 'failed' ? (
            <CloseCircleOutlined
              style={{ color: '#FE650F', marginRight: '5px' }}
            />
          ) : type == 'stoped' ? (
            <StopOutlined style={{ color: '#F5A722', marginRight: '5px' }} />
          ) : type == 'stopping' ? (
            <span
              className="iconfont icon-dengdai--copy"
              style={{ color: '#9A3232', marginRight: '5px',fontSize:"38px" }}
            />
          ) : (
            ''
          )}
        </div>
        <div className={cardStyle.statusInfo}>
          <div
            style={{
              width: 30,
              height: 34,
              //fontFamily: 'DIN',
              color: type == 'running' ? '#3C85FF':type == 'success'?'#00D1A3': type == 'failed'?'#FE650F':'#F5A722',
              fontSize: 24,
              marginBottom: 10,
            }}
          >
            {num}
          </div>
          <div style={{ fontSize: 16 }}>{label}</div>
        </div>
      </div>
    )
  } else if (mode === 'oam') {
    return (
      <div
        className={oamCardStyle.cardBox}
        style={
          type == 'running'
            ? {
                backgroundImage:
                  'linear-gradient(155.77deg,#3c85ff 0%,#7faefa 100%)',
              }
            : type == 'success'
            ? {
                backgroundImage:
                  'linear-gradient(136.05deg,#00d1a3 0%,#3ff1ca 100%)',
              }
            : type == 'failed'
            ? {
                backgroundImage:
                  'linear-gradient(134.65deg,#fe650f 0%,#f59058 100%)',
              }
            : type == 'stoped'
            ? {
                backgroundImage:
                  'linear-gradient(157.35deg,#f5a722 0%,#f3c26f 100%)',
              }
            : {
                backgroundImage:
                  'linear-gradient(155.31deg,#9f6af5 0%,#be9afa 100%)',
              }
        }
      >
        <div className={oamCardStyle.statusBox}>
          {type == 'running' ? (
            <SyncOutlined style={{ color: '#fff', marginRight: '5px' }} />
          ) : type == 'success' ? (
            <CheckCircleOutlined
              style={{ color: '#fff', marginRight: '5px' }}
            />
          ) : type == 'failed' ? (
            <CloseCircleOutlined
              style={{ color: '#fff', marginRight: '5px' }}
            />
          ) : type == 'stoped' ? (
            <StopOutlined style={{ color: '#fff', marginRight: '5px' }} />
          ) : type == 'stopping' ? (
            <ClockCircleOutlined
              style={{ color: '#fff', marginRight: '5px' }}
            />
          ) : (
            ''
          )}
          {label}
        </div>
        <div className={oamCardStyle.statusInfo}>
          <div
            style={{
              fontFamily: 'DIN',
              color: '#fff',
              fontSize: 40,
              marginBottom: 10,
            }}
          >
            {num}
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div
        className={cardStyle.cardBox}
        style={
          type == 'running'
            ? {
                backgroundImage:
                  'linear-gradient(155.77deg,#3c85ff 0%,#7faefa 100%)',
              }
            : type == 'success'
            ? {
                backgroundImage:
                  'linear-gradient(136.05deg,#00d1a3 0%,#3ff1ca 100%)',
              }
            : type == 'failed'
            ? {
                backgroundImage:
                  'linear-gradient(134.65deg,#fe650f 0%,#f59058 100%)',
              }
            : type == 'stoped'
            ? {
                backgroundImage:
                  'linear-gradient(157.35deg,#f5a722 0%,#f3c26f 100%)',
              }
            : {
                backgroundImage:
                  'linear-gradient(155.31deg,#9f6af5 0%,#be9afa 100%)',
              }
        }
      >
        <div className={cardStyle.statusBox}>
          {type == 'running' ? (
            <SyncOutlined style={{ color: '#fff', marginRight: '5px' }} />
          ) : type == 'success' ? (
            <CheckCircleOutlined
              style={{ color: '#fff', marginRight: '5px' }}
            />
          ) : type == 'failed' ? (
            <CloseCircleOutlined
              style={{ color: '#fff', marginRight: '5px' }}
            />
          ) : type == 'stoped' ? (
            <StopOutlined style={{ color: '#fff', marginRight: '5px' }} />
          ) : type == 'stopping' ? (
            <ClockCircleOutlined
              style={{ color: '#fff', marginRight: '5px' }}
            />
          ) : (
            ''
          )}
        </div>
        <div className={cardStyle.statusInfo}>
          <div
            style={{
              width: 30,
              height: 34,
              fontFamily: 'DIN',
              color: '#fff',
              fontSize: 24,
              marginBottom: 10,
            }}
          >
            {num}
          </div>
          <div style={{ fontSize: 6, color: '#fff' }}>{label}</div>
        </div>
      </div>
    )
  }
}

export default StatusCard
